import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { VideoPlayer, Viewer } from '../../src/index';
import VersionTag from '../../docz/version-tag/index';
import Code from '../../docz/code/index';
import { name, version, peerDependencies } from '../../package.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h1 {...{
      "id": "react-trailer"
    }}>{`react-trailer `}<VersionTag version={version} name={name} mdxType="VersionTag" /></h1>
    <p>{`react-trailer is a wrapper around HTML5 video API that allows you to render videos in your React application.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`First of all, install the following `}<strong parentName="p">{`peer dependencies`}</strong>{`:`}</p>
    <Code language="bash" mdxType="Code">{`npm i ${Object.keys(peerDependencies).join(' ')}`}</Code>
    <p>{`To add the library to your project you can either use a CDN service:`}</p>
    <Code language="html" mdxType="Code">{`<script src="https://unpkg.com/${name}@${version}/index.js"></script>`}</Code>
    <p>{`Or npm to install the library from npm registry:`}</p>
    <Code language="bash" mdxType="Code">{`npm i --save ${name}`}</Code>
    <p>{`Or if you prefer yarn:`}</p>
    <Code language="bash" mdxType="Code">{`yarn add ${name}`}</Code>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <VideoPlayer mdxType="VideoPlayer">
  <Viewer url="https://d2zihajmogu5jn.cloudfront.net/elephantsdream/ed_hd.mp4" nativeControls mdxType="Viewer" />
    </VideoPlayer>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Code language="jsx" mdxType="Code">
  {`
import { VideoPlayer, Viewer } from 'react-trailer';\n
<VideoPlayer>
  <Viewer
    url="http://dl5.webmfiles.org/big-buck-bunny_trailer.webm"
    nativeControls
  />
</VideoPlayer>
  `.trim()}
    </Code>
    <h2 {...{
      "id": "development"
    }}>{`Development`}</h2>
    <Code language="bash" mdxType="Code">
  npm i && npm start
    </Code>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      